import { IFormProps } from 'interfaces'
import React, { useEffect } from 'react'
import CompanyLogo from '../../../assets/afbc.png'
import CompleteIcon from '../../../assets/complete.png'
import Side1 from '../../../assets/investing-signup-images/success-cheers.jpg'

const SuccessReinvestment = (props: IFormProps) => {
  useEffect(() => {
    props.currentStep === 'Success' && props.reset()
  }, [props.currentStep]) // eslint-disable-line

  return (
    <div className="flex h-screen w-full flex-col md:flex-row md:justify-start">
      <div className="mt-10 flex flex-col sm:w-screen md:mt-0 md:min-h-screen md:w-[45%] lg:w-[40%] xl:w-[35%]">
        <div className="relative w-screen px-10 sm:h-auto sm:px-16 md:hidden">
          <img className="w-screen" src={CompanyLogo} alt="CompanyLogo" />
        </div>
        <div className="relative hidden flex-grow md:flex">
          <img className="flex h-screen w-full" src={Side1} alt="Side1" />
        </div>
      </div>

      <div className="flex flex-col p-4 sm:w-[100%] md:h-screen md:w-[70%] md:overflow-y-scroll md:p-10">
        <div className="mb-10 hidden justify-center md:flex">
          <div className="w-1/2">
            <img className="w-screen" src={CompanyLogo} alt="CompanyLogo" />
          </div>
        </div>

        <div className="flex w-full justify-center">
          <div className="pb-10 pt-2 text-center text-3xl font-semibold text-gray-900 sm:text-left md:text-left md:text-4xl">
            Investment Submitted!
          </div>
        </div>
        <div className="relative flex justify-center">
          <img className="flex w-1/2 md:w-1/4" src={CompleteIcon} alt={`${CompleteIcon}`} />
        </div>
        <div className="mt-4 text-center text-base text-gray-500 md:leading-5">
          You've successfully submitted your investment commitment for Armed Forces Brewing Co. Please keep an eye out
          in your email as you will be receiving further details regarding your investment and what to expect next.
        </div>
      </div>
    </div>
  )
}

export default SuccessReinvestment
